<script>
import formatPaymentMethod from "@utils/format-payment-method";
import { merchantComputed } from "@store/helpers";
import formatDate from '@utils/format-date'
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";
import  { formatOrder } from "@utils/format-order";
import {
  orderAtmInfoList,
  orderInfoList,
  orderIsOffline,
  orderIsUseDeduct,
  orderIsPrepaidUnpaidAndDeduct,
  orderVaccInfoList,
  orderBillingReservationList,
  orderReserveParamsList
} from "@utils/ipetbooking-order";

export default {
  components: {
    OrderPaymentButton: () => import("@components/Order/OrderPaymentButton"),
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    containerItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    formatPaymentMethod,
    formatDate,
    formatOrder,
    isUseDeduct(orderItem) {
      return orderIsUseDeduct({ ...orderItem })
    },
    isUnpaidAndDeduct(orderItem) {
      return orderIsPrepaidUnpaidAndDeduct({ ...orderItem })
    },
    // orderBillingList(orderItem) {
    //   // return orderBillingReservationList({
    //   //   type: 'memberOrder',
    //   //   ...orderItem,
    //   //   isUnpaidAndDeduct: this.isUnpaidAndDeduct
    //   // });

    // },
    orderBillingList(orderItem) {
      const paramsList = (typeList) => {
        return orderReserveParamsList({
            typeList,
            params: orderItem.params,
          });
        };
      return conditionList([
        ...paramsList(['daycare-add','cosmetic-add']),
        {
          type: 'hr'
        },
        {
          title: '小計',
          text: `${formatPrice(paramsList(['daycare-add','cosmetic-add']).reduce((a,b)=> {
              return a+(b.total);
          },0))}`,
          textClass: 'font-number'
        },
        ...paramsList(['+', '-', '%']),
        {
          type: 'hr'
        },
        {
          title: '總計',
          text: formatPrice(orderItem.priceTotal),
          class: 'align-items-end',
          textClass: 'text-primary-dark font-number fw-semi-bold fs-xl'
        },
      ]);
    },
    isOffline(childrenOrderItemItem) {
      return orderIsOffline({
        order: childrenOrderItemItem,
        ordertype: 'order',
        type: 'reservation'
      });
    },
    orderInfoList(childrenOrderItemItem) {
      return orderInfoList({ ...childrenOrderItemItem });
    },
    vaccInfoList(childrenOrderItemItem) {
      return orderVaccInfoList({ ...childrenOrderItemItem, unpaid: childrenOrderItemItem.total })
    },
    atmInfoList(childrenOrderItemItem) {
      return orderAtmInfoList({ ...childrenOrderItemItem, unpaid: childrenOrderItemItem.total })
    },
    currentContainerChildrenOrder(childrenOrderItem) {
      return this.containerItem?.childrenContainers?.items.find((item) => {
        return item.uuid === childrenOrderItem.containerUuid
      })
    },

  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.reservationItemSectionItemChildren">
    <div>
      <div v-if="orderItem.childrenOrders[0]">
        <ul
          v-for="(childrenOrderItem, index) in orderItem.childrenOrders"
          :key="index"
          :class="[$style.detailList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
        >
          <li class="detailList__item isTitle d-flex flex-md-row flex-column justify-content-between">
            <span class="order-md-0 order-3">訂單編號：#{{ childrenOrderItem.containerDisplayId }}</span>
            <span class="text-gray-2 order-md-0 order-2">訂單成立時間: {{ formatDate(currentContainerChildrenOrder(childrenOrderItem).createdDate, 'yyyy/MM/dd EEE HH:mm')  }}</span>
            <span :class="`text-${formatOrder(childrenOrderItem).color} order-md-0 order-1`">
              {{ formatOrder(childrenOrderItem).title }}
            </span>
          </li>
          <li
            v-if="!!orderBillingList(childrenOrderItem)[0]"
            class="detailList__item"
          >
            <div class="row">
              <!-- <div class="col-md-3">
                <div class="detailList__title">
                  訂單明細
                </div>
              </div> -->
              <div class="col-md-12">
                <BaseList
                  :data-list="orderBillingList(childrenOrderItem)"
                  type="order"
                />
              </div>
            </div>
          </li>
          <li
            v-if="!!orderInfoList(childrenOrderItem)[0]"
            class="detailList__item"
          >
            <div class="row">
              <div class="col-md-3">
                <div class="detailList__title">
                  訂單資訊
                </div>
              </div>
              <div class="col-md-9">
                <BaseList
                  :data-list="orderInfoList(currentContainerChildrenOrder(childrenOrderItem))"
                  type="info"
                />
              </div>
            </div>
            <OrderPaymentButton
              :order-item="currentContainerChildrenOrder(childrenOrderItem)"
              type="memberOrderReservationChildren"
              button-class="mt-5"
            />
          </li>
          <li
            v-if="(childrenOrderItem.paymentMethod === 'Vacc' && !!vaccInfoList(childrenOrderItem)[0]) || childrenOrderItem.paymentMethod === 'Atm' && !!atmInfoList(childrenOrderItem)[0]"
            class="detailList__item"
          >
            <div class="row">
              <div class="col-md-3">
                <div class="detailList__title">
                  匯款資訊
                </div>
              </div>
              <div class="col-md-9">
                <BaseList
                  v-if="childrenOrderItem.paymentMethod === 'Vacc' && !!vaccInfoList(childrenOrderItem)[0]"
                  :data-list="vaccInfoList(childrenOrderItem)"
                  type="info"
                />
                <BaseList
                  v-if="childrenOrderItem.paymentMethod === 'Atm' && !!atmInfoList(childrenOrderItem)[0]"
                  :data-list="atmInfoList(childrenOrderItem)"
                  type="info"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <BasePre>{{ orderItem }}</BasePre> -->
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.reservationItemSectionItemChildren {
  :global {
    .reservationItemSectionItemChildren {
      @include unstyled;
    }
  }
}

.detailList {
  @include list-unstyled;

  margin: 0 0 2rem;

  :global {
    .detailList {
      &__item {
        &:not(:last-child) {
          padding-bottom: 2rem;
          border-bottom: 1px solid $color-line;
        }

        &:not(:first-child) {
          padding-top: 2rem;
        }

        &.isTitle {
          padding: 1.5rem;
          color: $color-primary-dark;
          background: rgba($color-primary, 0.2);
          border-bottom: unset;
        }
      }

      &__title {
        @extend %FontSerifWeightJtails;

        @include max-md {
          margin-bottom: 1.5rem;
          // color: $color-blue-dark;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .detailList {
        &__title {
          font-family: unset;
          font-weight: 400;
          color: $color-secondary;
        }
      }
    }
  }
}
</style>
